import { StandardProps } from "@/components/componentMap";
import * as groupedComponents from "./index";

type StandardGroupedComponent = (props: StandardProps) => React.ReactNode;
type StandardGroupedComponentMap = { [name: string]: StandardGroupedComponent };

export const groupedComponentMap: StandardGroupedComponentMap =
  groupedComponents;
